import React, { useState, useEffect } from "react";
import Api from "../util/api";
import Util from "../util/util";
import Settings from "../config/settings";
import swal from 'sweetalert2';
import useLoading from "../hooks/useLoading";
import { Turnstile } from '@marsidev/react-turnstile';
import { useRef } from 'react';
import PropTypes from "prop-types";

function FormNuevoProspecto({onSuccess, onError}) {
  const [estado, setEstado] = useState("idle"); // idle | enviando | listo | error
  const turnstileRef = useRef(null);
  const {startLoading, stopLoading } = useLoading();
  const [state, setState] = useState({
    prospecto: {
      nombre: "",
      organizacion: "",
      email: "",
      telefono: "",
      producto: "",
      idea: "",
      acepta: false,
    },
  });

  const INTERESES = [
    { value: "innovacion", label: "Estrategias de Innovacion" },
    { value: "ia", label: "Inteligencia artificial" },
    { value: "gestion_documentos", label: "Gestión inteligente de documentos" },
    { value: "software", label: "Desarrollo de software" },
    { value: "automatizacion", label: "Automatización inteligente" },
    { value: "certificacion", label: "Certificación de documentos con blockchain" },
    { value: "n/a", label: "Por ahora sólo quiero saber más de LifeChain" },
  ];

  const handleChange = (e) => {
    const { id, type, value, checked } = e.target;
    setState((prevState) => ({
      ...prevState,
      prospecto: {
        ...prevState.prospecto,
        [id]: type === "checkbox" ? checked : value,
      },
    }));
  };

  useEffect(()=>{
    validateToken();
  },[]);

  const validateToken = async () => {
    const userString = localStorage.getItem("user");

    if (!userString) return;
    const user = JSON.parse(userString);
    if (!user) return;
    const res = await Api.usuarios.get(user._id);
    var data = await res.json();
    setState((prevState)=>({
      ...state,
      prospecto: {
        ...prevState.prospecto,
        nombre: data.usuario?.nombre || '',
        email: data.usuario?.email || '',
      }
    }))
  }

  async function crearProspecto(e) {
    e.preventDefault();

    try {
      const captchaToken = turnstileRef.current?.getResponse();
      if(!captchaToken){
        await swal.fire("Ups!", "Captcha aún no generado", "error");
        return;
      }
      setEstado("enviando");
      startLoading();
      var res = await Api.prospectos.crear({
        ...state.prospecto,
        captchaToken,
      });
      stopLoading();
      if (!(await Util.requestSuccess(res))) {
        setEstado("error");
        turnstileRef.current?.reset();
        onError?.();
        return;
      }
      setEstado("listo");
      onSuccess?.();
    } catch (e) {
      console.log(e);
      stopLoading();
      setEstado("error");
      turnstileRef.current?.reset();
      onError?.();
    }
  }

  const reintentar = () => setEstado("idle");
  
  if (estado === "listo") {
    return (
        <div className="text-center py-5">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-4 mb-4"
               style={{ width: 80, height: 80 }}>
            <i className="fas fa-check font-xl color-1"></i>
          </div>
          <h4 className="bold mb-2">¡Listo, lo recibimos!</h4>
          <p className="color-2 mb-0">
            Gracias por compartirnos tu idea, en breve nos comunicaremos contigo.
          </p>
        </div>
    );
  }

  if (estado === "error") {
    return (
        <div className="text-center py-5">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-3 mb-4"
               style={{ width: 80, height: 80 }}>
            <i className="fas fa-exclamation font-xl color-1"></i>
          </div>
          <h4 className="bold mb-2">No pudimos enviar tus datos</h4>
          <p className="color-2 mb-4">
            Revisa tu conexión e inténtalo de nuevo.
          </p>
          <button onClick={reintentar} className="btn btn-accent btn-rounded">
            Reintentar
          </button>
        </div>
    );
  }

  return (
      <form>
        <div className="form-group">
          <input id="nombre" className="form-control bg-1" placeholder="Nombre"
                 value={state.prospecto?.nombre} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <input id="organizacion" className="form-control bg-1"
                 placeholder="Empresa o proyecto (opcional)"
                 value={state.prospecto?.organizacion} onChange={handleChange} />
        </div>
        <div className="form-group">
          <input id="email" type="email" className="form-control bg-1"
                 placeholder="Correo" value={state.prospecto?.email}
                 onChange={handleChange} required />
        </div>
        <div className="form-group">
          <input id="telefono" className="form-control bg-1"
                 placeholder="Teléfono (opcional)"
                 value={state.prospecto?.telefono} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="producto" className="bold">
            ¿Qué quieres resolver?
          </label>
          <select id="producto" className="form-control bg-1"
                  style={{ height: "50px" }} value={state.prospecto?.producto}
                  onChange={handleChange}>
            {INTERESES.map((i) => (
                <option key={i.value} value={i.value}>{i.label}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
													<textarea id="idea" className="form-control bg-1" rows="4"
                                                              placeholder="Cuéntanos más (opcional)"
                                                              value={state.prospecto?.idea} onChange={handleChange} />
        </div>

        <p className="color-2 mb-4">
          <input type="checkbox" id="acepta" checked={state.prospecto?.acepta}
                 onChange={handleChange} required /> Acepto el{" "}
          <a href="/aviso-de-privacidad" target="_blank" rel="noreferrer">aviso de privacidad</a>{" "}
          y las <a href="/bases-feria" target="_blank" rel="noreferrer">bases de la promoción</a>
        </p>

        <div className="form-group">
          <Turnstile ref={turnstileRef} siteKey={Settings.turnstile_key} />
          <button onClick={crearProspecto} disabled={estado === "enviando"}
                  className="btn btn-accent btn-rounded">
            {estado === "enviando" ? "Enviando..." : "Quiero mi diagnóstico y mis certificaciones"}
          </button>
        </div>
      </form>
  );
}

FormNuevoProspecto.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};

export default FormNuevoProspecto;
